import { ToolBarStandardButton, ToolBarStandardButtonType } from "../../core/components/toolBar";
import { Config } from "../../core/config/config";
import { Grid } from "../../core/components/grid";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { Helper } from "../../core/util/helper";
import { Dialog, DialogProps } from "../../core/components/dialog";
import { TranslationTextBox, TranslationTextBoxProps} from "../../core/components/translationTextBox";
import { FieldInstance } from "../../core/components/field";
import { ComponentHelper } from "../../core/util/componentHelper";
import { DialogHelper } from "../../core/util/dialogHelper";
import { NotificationHelper } from "../../core/util/notificationHelper";
import { ContextGeneralSettingsApp } from "../generalSettings";
import React from "react";
export default class EditStatus extends React.Component<EditStatusProps, EditStatusState> {
    private _factory = ComponentHelper.createFactory();
    private _translations: string[] = [];
    private _gridOptions = null;
    private _dialogProps: DialogProps = {
        title: Config.translations.editLabel,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => { }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    let isValid = Helper.hasValue(this.state.currentStatus.Translations) && this.state.currentStatus.Translations.filter((f: any) => !Helper.isNullOrEmpty(f.Value)).length > 0;
                    if (isValid) {
                        this._save();
                    } else {
                        DialogHelper.alert(this._translations["Standard.PflichtfeldAllgemein"]);
                        return false;
                    }
                },
                primary: true
            }
        ],
        afterClose: () => {
            this._closeDialog();
        },
        width: 500
    };

    constructor(props: EditStatusProps) {
        super(props);
        this._gridOptions = props.context.editMaschineStatusGridOptions;
        this._translations = props.context.translations;
        this.state = {
            gridData: [],
            dialogOpen: false,
            currentStatus: null,
            enableDeleteButton: false
        };    
    }

    private _createDialog = () => {
        return (
            <div>
                <Dialog {...this._dialogProps} open={true} >
                    {this._createTextBox()}
                </Dialog>
            </div>
        );
    }

    private _createTextBox = () => {
        let props: TranslationTextBoxProps = this._factory.getDefaultTranslationTextBoxProps();
        props.language = "Key";
        props.translation = "Value";
        props.value = this.state.currentStatus.Translations;

        props.onChange = (field: { model: string }, value: any, dataItem?: any) => {
            let status = this.state.currentStatus;
            status.Translations = value;
            this.setState({ currentStatus: status });
        }

        return (
            <FieldInstance label={this._translations["Standard.Name"] + "*"} noHover={true}>
                <TranslationTextBox {...props} />
            </FieldInstance>
        );

    }


    private _closeDialog = () => {
        this.setState({ dialogOpen: false });
    }

    private _openDialog = (dataItem: Status = null) => {
        if (!Helper.hasValue(dataItem)) {
            dataItem = {
                Id: -1,
                IsDeletable: true,
                IsNew: true,
                IsRowId: null,
                Translations: null,
                Name: ""
            }
        }
        this.setState({
            dialogOpen: true,
            currentStatus: dataItem
        });
    }

    private _save = () => {
        HTTPService.post<JsonResultClass>("MachineSettings/SaveStatus", { model: this.state.currentStatus })
            .then(result => {
                if (result.Code == 0) {
                    this._getGridData();
                } else {
                    NotificationHelper.showErrorMessage(result.Message);
                }
            });
    }

    private _delete = (dataItem: Status) => {
        DialogHelper.confirm(Config.translations.deleteMessage).then(isOk => {
            if (isOk) {
                HTTPService.post<JsonResultClass>("MachineSettings/DeleteStatus", { model: dataItem })
                    .then(result => {
                        if (result.Code == 0) {
                            this._getGridData();
                        } else {
                            NotificationHelper.showErrorMessage(result.Message);
                        }
                    });
            }
        });
    }
    
    private _getGridData = () => {
        const url = "MachineSettings/GetAllStatus";
        HTTPService.get<JsonResultClass<Status[]>>(url)
            .then(result => {
                if (result.Code == 0) {
                    this.setState({ gridData: result.Data });
                }
            });
    }

    private _createGrid = () => {
        const standardButtons: Array<ToolBarStandardButton> = [];
        standardButtons.push({ type: ToolBarStandardButtonType.NEW, caption: Config.translations.newLabel, enabled: true });
        standardButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: Config.translations.editLabel, enabled: true });
        standardButtons.push({ type: ToolBarStandardButtonType.DELETE, caption: Config.translations.deleteLabel, enabled: true });
        let grid = (
            <Grid data={this.state.gridData} options={this._gridOptions} id="generalSettings_EditStatusGrid"
                standardButtons={standardButtons} onClickStandardButton={this._handleClickStandardButton}
                onSelectionChanged={this._onSelectionChanged} />
        );
        return (
            <div style={{ height:"300px" }}>
                {grid}
            </div>    
        )
    }

    private _onSelectionChanged = (dataItem: Status) => {
        if (Helper.hasValue(dataItem)) {
            this.setState({ enableDeleteButton: dataItem.IsDeletable });
        } else {
            this.setState({ enableDeleteButton: false });
        }
    }

    private _handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: Status) => {
        switch (type) {
            case (ToolBarStandardButtonType.EDIT):
                this._openDialog(dataItem);
                break;
            case (ToolBarStandardButtonType.NEW):
                this._openDialog();
                break;
            case (ToolBarStandardButtonType.DELETE):
                this._delete(dataItem);
                break;
        }
    }

    componentDidMount() {
        this._getGridData();
    }

    render() {
        const grid = this._createGrid();
        const dialog = this.state.dialogOpen ? this._createDialog() : <></>;
        return (
            <>
                {grid}
                {dialog}
            </>);
    }
};

interface EditStatusProps {
    context: ContextGeneralSettingsApp;
}

interface EditStatusState {
    gridData: Status[];
    dialogOpen: boolean;
    enableDeleteButton: boolean;
    currentStatus: Status;
}

interface Status{
    Id: number;
    Name: string;
    Translations: [];
    IsNew: boolean;
    IsDeletable: boolean;
    IsRowId: number;
}